import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "text-h5 text-center" }, "Восстановление пароля", -1)

import { ref } from 'vue'
import { AppAuthService, LOGIN_TYPE_INFO, LoginType } from '@prodcard/core'
import { useVuelidate } from '@vuelidate/core'
import { required, email as emailValidator, helpers } from '@vuelidate/validators'
import { map } from 'lodash'
import { callErrorToast, createCtx, handleError } from '../../../helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetForm',
  props: {
    authService: {},
    preFilledEmail: {}
  },
  emits: ["login"],
  setup(__props: any, { emit }) {

const props = __props;




const email = ref(props.preFilledEmail || '')
const emailChanged = ref(true)

const loginTypes = map(LoginType, lt => ({ value: lt, title: LOGIN_TYPE_INFO[lt] }))
const loginType = ref(loginTypes[0].value)

const controlQuestion = ref('')
const loadingControlQuestion = ref(false)
const controlAnswer = ref('')

const authCode = ref('')
const loading = ref(false)

const validatorForEmail = useVuelidate(
  {
    email: {
      required: helpers.withMessage('Email не может быть пустым', required),
      email: helpers.withMessage('Email некорректен', emailValidator),
    },
  },
  { email },
)

const validatorForControlAnswer = useVuelidate(
  {
    controlAnswer: {
      required: helpers.withMessage('Ответ не может быть пустым', required),
    },
  },
  { controlAnswer },
)

const validatorForAuthCode = useVuelidate(
  {
    authCode: {
      required: helpers.withMessage('Код регистрации не может быть пустым', required),
    },
  },
  { authCode },
)

const loadControlQuestion = (email: string) => {
  handleError(async () => {
    const valid = await validatorForEmail.value.$validate()
    if (!valid) return

    const response = await props.authService.getControlQuestion(createCtx(), email)
    controlQuestion.value = response ?? ''
    emailChanged.value = false
  }, loadingControlQuestion)
}

const loginBy = () => {
  handleError(async () => {
    let valid, answer

    if (loginType.value === LoginType.AUTH_CODE) {
      valid = await validatorForAuthCode.value.$validate()
      answer = authCode.value
    } else {
      valid = await validatorForControlAnswer.value.$validate()
      answer = controlAnswer.value
    }

    if (!valid || !answer) return

    const response = await props.authService.loginBy(createCtx(), loginType.value, email.value, answer)
    if (response?.message) {
      callErrorToast(response.message)
    } else {
      emit('login')
    }
  }, loading)
}

if (email.value && !validatorForEmail.value.$invalid && !controlQuestion.value) {
  loadControlQuestion(email.value)
}

if (email.value && validatorForEmail.value.$invalid) {
  validatorForEmail.value.email.$touch()
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    loading: loading.value,
    disabled: loading.value,
    elevation: "3",
    variant: "flat",
    class: "pa-5"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    label: "Email*",
                    modelValue: email.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    "error-messages": _unref(validatorForEmail).email.$errors.map(e => e.$message).join(),
                    disabled: loading.value || loadingControlQuestion.value,
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (!emailChanged.value ? (emailChanged.value = true) : undefined)),
                    onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (!email.value || emailChanged.value ? loadControlQuestion(email.value) : loginBy()), ["enter"]))
                  }, null, 8, ["modelValue", "error-messages", "disabled"])
                ]),
                _: 1
              }),
              (email.value && !emailChanged.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: loginType.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loginType).value = $event)),
                          items: _unref(loginTypes),
                          disabled: loading.value
                        }, null, 8, ["modelValue", "items", "disabled"])
                      ]),
                      _: 1
                    }),
                    (loginType.value === _unref(LoginType).CONTROL_QUESTION)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            (controlQuestion.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("p", {
                                    class: _normalizeClass(["text-body-1", { 'text-grey': loading.value }])
                                  }, _toDisplayString(controlQuestion.value), 3),
                                  _createVNode(_component_v_text_field, {
                                    modelValue: controlAnswer.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((controlAnswer).value = $event)),
                                    "error-messages": _unref(validatorForControlAnswer).controlAnswer.$errors.map(e => e.$message).join(),
                                    disabled: loading.value,
                                    label: "Ответ на контрольный вопрос*",
                                    maxlength: "100",
                                    class: "mt-3",
                                    onKeyup: _withKeys(loginBy, ["enter"])
                                  }, null, 8, ["modelValue", "error-messages", "disabled", "onKeyup"])
                                ], 64))
                              : (_openBlock(), _createElementBlock("p", {
                                  key: 1,
                                  class: _normalizeClass(["text-body-1", { 'text-grey': loading.value }])
                                }, "Контрольный вопрос не был задан", 2))
                          ]),
                          _: 1
                        }))
                      : (loginType.value === _unref(LoginType).AUTH_CODE)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: authCode.value,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((authCode).value = $event)),
                                disabled: loading.value,
                                "error-messages": _unref(validatorForAuthCode).authCode.$errors.map(e => e.$message).join(),
                                label: "Код регистрации*",
                                maxlength: "100",
                                onKeyup: _withKeys(loginBy, ["enter"])
                              }, null, 8, ["modelValue", "disabled", "error-messages", "onKeyup"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    loading: loadingControlQuestion.value || loading.value,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (!email.value || emailChanged.value ? loadControlQuestion(email.value) : loginBy()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Далее ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading", "disabled"]))
}
}

})